import { PcbNodeTypes } from "@buildwithflux/models";
import { capitalize } from "lodash";
export function humanizePcbLayoutNodeType(type) {
    switch (type) {
        case PcbNodeTypes.routeSegment: {
            return "Trace";
        }
        case PcbNodeTypes.smartVia: {
            return "Smart Via";
        }
        default: {
            return capitalize(type);
        }
    }
}
//# sourceMappingURL=humanizePcbLayoutNodeType.js.map